import React from 'react'
import { Link } from 'react-router-dom'

export const PurpleLogoLink:React.FunctionComponent = () => {
  return (
    <Link to="/"><img src="/images/purple-logo.svg" alt='Predictagram' style={{ maxWidth: "200px" }} /></Link>

  )
}
